/* eslint-disable react/destructuring-assignment */
import React from 'react';

const StarIcon = (props: any) => {
  return (
    (<svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      className={props.className}
      data-palette="StarIcon">
      <defs>
        <linearGradient id="prefix__a" x1="-1.158%" x2="79.146%" y1="4.778%" y2="83.574%">
          <stop offset="0%" stopColor="#FEE733" />
          <stop offset="100%" stopColor="#FCCA17" />
        </linearGradient>
      </defs>
      <g fill="none" fillRule="evenodd">
        <path d="M0 0L14 0 14 14 0 14z" />
        <path
          fill="url(#prefix__a)"
          d="M7 10.652L2.886 12.955 3.804 8.33 0.342 5.129 5.025 4.573 7 0.292 8.975 4.573 13.658 5.129 10.195 8.33 11.114 12.955z"
        />
      </g>
    </svg>)
  );
};

export default StarIcon;
